// React
import React, {useState, useEffect} from "react";

// External libraries
import {faClipboard, faClipboardCheck} from "@fortawesome/sharp-solid-svg-icons";

// Internal
import {InputCopyButton} from "./input-clipboard-copy-button";
import {InputErrorIndicator} from "./input-error-indicator";
import {InputIcon} from "./input-icon";

// CSS
import "./inputs.css";

export const TimespanUnit = {
    Second: 1,
    Minute: 2,
    Hour: 3,
    Day: 4,
    MinuteSecond: 5,
    HourMinute: 6,
    HourMinuteSecond: 7
};

function InputTimeSpan(props) {
    const [value, setValue] = useState("");
    const [editing, setEditing] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (props.Value) {
            setValue(props.Value.toString().replace(/:/g, "").replace(/^[0]+/g, ""));
        } else {
            setValue("");
        }
    }, [props.Value]);

    const changeValue = (e) => {
        setValue(e.target.value.replace(/\D/g, ""));
    };

    const focus = () => {
        setEditing(true);
    };

    const blurValue = () => {
        setEditing(false);
        if (typeof props.OnBlur === "function") {
            props.OnBlur(getMaskedValue());
        }
    };

    const getMask = () => {
        switch (props.DisplayUnit) {
            case TimespanUnit.HourMinute:
            case TimespanUnit.MinuteSecond:
                return "0:00";
            case TimespanUnit.HourMinuteSecond:
                return "0:00:00";
            default:
                return "";
        }
    };

    const getMaskedValue = () => {
        const mask = getMask();
        if (mask) {
            const maskArray = mask.split("").reverse();
            const valueArray = value.split("").reverse();
            for (let i = 0, len = maskArray.length; i < len; i++) {
                if (maskArray[i] === "0" && valueArray.length > 0) {
                    maskArray[i] = valueArray.shift();
                }
            }
            for (let i = 0, len = valueArray.length; i < len; i++) {
                maskArray.push(valueArray[i]);
            }
            return maskArray.reverse().join("");
        } else {
            return value;
        }
    };

    const copyToClipboard = async () => {
        setCopied(true);
        setTimeout(clearCopiedState, 5000);
        await navigator.clipboard.writeText(props.Value ?? "");
    };

    const clearCopiedState = () => {
        setCopied(false);
    };

    const getClipboardIcon = () => {
        return copied ? faClipboardCheck : faClipboard;
    };
    
    const getContainerClass = () => {
        if (props.ContainerClass) {
            return props.ContainerClass;
        }
        if (editing) {
            return "eone-ui-input-container eone-ui-input-container-focused";
        }
        return "eone-ui-input-container";
    };

    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }
    
    return (
        <div className={getContainerClass()}>
            <InputIcon Icon={props.Icon} DataTestId={props.DataTestId}/>
            <input
                type="text"
                autoFocus={props.AutoFocus}
                className="eone-ui-input-string"
                onChange={changeValue}
                onBlur={blurValue}
                onFocus={focus}
                value={editing ? value : props.Value}
                data-testid={props.DataTestId}/>
            <InputCopyButton
                Show={props.ShowCopyButton}
                Icon={getClipboardIcon()}
                Copy={copyToClipboard}
                DataTestId={props.DataTestId}/>
            <InputErrorIndicator
                Error={errorMessage || props.ErrorMessage}
                DataTestId={props.DataTestId}/>
        </div>
    );
}

export {InputTimeSpan};